import { BaseRouteService } from 'core/services';

class ProductInventoryRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'product-inventories/';
	}
	
	createBatch(sourceOfChange) {
		return super.create(this.base + 'batch/?sourceOfChange={sourceOfChange}', {sourceOfChange});
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	sync() {
		return super.create(this.base + 'sync');
	}

	syncWithWms(sourceOfChange) {
		return super.create(this.base + 'sync-product-inventory-per-warehouse/?sourceOfChange={sourceOfChange}', {sourceOfChange});
	}

	syncInventoryForAllWarehouses(sourceOfChange) {
		return super.create(this.base + 'sync-product-inventory-for-all-warehouses/?sourceOfChange={sourceOfChange}', {sourceOfChange});
	}

	syncInventoryForSeller(sourceOfChange) {
		return super.create(this.base + 'sync-product-inventory-for-seller/?sourceOfChange={sourceOfChange}', {sourceOfChange});
	}

	exportInventoryByDate(sourceOfChange) {
		return super.create(this.base + 'export-inventory-by-date/?sourceOfChange={sourceOfChange}', {sourceOfChange});
	}
}

export default ProductInventoryRouteService;
